"use client";

import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import AgentCard, { Agent } from "./AgentCard";

export default function AgentsSection({
  t,
  titleKey = "agents_title",
  agents,
}: {
  t: (key: string, vars?: Record<string, any>) => string;
  titleKey?: string;
  agents: Agent[];
}) {
  return (
    <Box>
      <Stack spacing={0.6} sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 900, letterSpacing: -0.3 }}>
          {t(titleKey)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t("brand_tagline")}
        </Typography>
      </Stack>

      {/* Responsive grid: 1 column on mobile, 2 columns on md+ */}
      <Box
        sx={{
          display: "grid",
          gap: 2.2,
          gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
        }}
      >
        {agents.map((a) => (
          <Box key={a.name} sx={{ minWidth: 0 }}>
            <AgentCard agent={a} t={t} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
